import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthentificationService {
  public initialiser(): void {
    authentification.initialiser();
  }
}
